/**
 * Readable names for the records the console shows (item 68). The backend identifies a document by a long
 * hex id; people read and say "INC-B2E8". The label is the last four characters of that id, so the same
 * record has the same label everywhere. It is not a sequence number: a stable one has to come from the
 * backend (docs/c3/BACKEND.md, item 68). An id that is already a readable label ("INC-4021") is kept.
 */
const TAIL = 4;

function label(prefix: string, id: string | null | undefined): string {
  const raw = String(id ?? '').trim();
  if (!raw) return '—';
  if (raw.toUpperCase().startsWith(`${prefix}-`)) return raw.toUpperCase();
  const hex = raw.replace(/[^a-fA-F0-9]/g, '');
  const source = hex.length >= TAIL ? hex : raw.replace(/[^a-zA-Z0-9]/g, '');
  return `${prefix}-${source.slice(-TAIL).toUpperCase()}`;
}

/** "INC-B2E8" for an incident, which is a threat event or its action. */
export function incidentLabel(id: string | null | undefined): string {
  return label('INC', id);
}

/** "CAMP-B2E8" for a campaign. */
export function campaignLabel(id: string | null | undefined): string {
  return label('CAMP', id);
}
